import { render } from "./ModalWithButtons.vue?vue&type=template&id=0c6d25cb&scoped=true"
import script from "./ModalWithButtons.vue?vue&type=script&lang=js"
export * from "./ModalWithButtons.vue?vue&type=script&lang=js"

import "./ModalWithButtons.vue?vue&type=style&index=0&id=0c6d25cb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6d25cb"]])

export default __exports__